import Tagify from "@yaireo/tagify"

// Affiliate promotion profile forms (the public application and the affiliate
// dashboard's profile editor): repeatable channel link rows, select2 dropdowns
// and a Tagify topic picker styled like the creator product tags field.
$(document).on("turbolinks:load", function () {
  const form = $(".js-affiliate-profile-form")
  if (!form.length) return

  const paramKey = form.data("paramKey") || "affiliate_application"

  const list = form.find(".js-channel-links")
  const template = form.find(".js-channel-link-template")

  function renumber() {
    list.find(".js-channel-link-input").each(function (index) {
      $(this).attr("id", paramKey + "_channel_links_" + index)
    })
  }

  form.on("click", ".js-add-channel-link", function () {
    const row = $(template.html())
    list.append(row)
    renumber()
    row.find("input").trigger("focus")
  })

  form.on("click", ".js-remove-channel-link", function () {
    const rows = list.find(".js-channel-link-row")
    if (rows.length > 1) {
      $(this).closest(".js-channel-link-row").remove()
    } else {
      rows.first().find("input").val("")
    }
    renumber()
  })

  // Every <select> in the form gets select2 for consistent styling. Long
  // option lists (country, time zone, topics) are searchable and use their
  // prompt as a clearable placeholder; short lists opt out via data-search="false"
  // and behave like a plain styled dropdown.
  form.find(".js-affiliate-select2").each(function () {
    const select = $(this)
    if (typeof select.select2 !== "function") return
    if (select.hasClass("select2-hidden-accessible")) return

    const options = { width: "100%" }
    if (select.data("search") === false) {
      options.minimumResultsForSearch = Infinity
    } else {
      options.placeholder = select.data("placeholder") || ""
      options.allowClear = !select.prop("multiple")
    }
    select.select2(options)
  })

  // Topics: whitelist entries are { value: name, id }, and the original input
  // is written back as a comma-separated list of ids for the model.
  form.find(".js-affiliate-tags").each(function (index, el) {
    if (el.tagifyInstance) return

    const whitelist = $(el).data("taglist") || []
    el.tagifyInstance = new Tagify(el, {
      placeholder: "Search topics ...",
      whitelist: whitelist,
      enforceWhitelist: true,
      delimiters: ",",
      skipInvalid: true,
      dropdown: {
        enabled: 0,
        maxItems: 20,
        closeOnSelect: false,
        highlightFirst: true,
      },
      originalInputValueFormat: function (values) {
        return values
          .map(function (item) {
            return item.id
          })
          .join(",")
      },
    })
  })
})
